export type ClassroomContentTab = 'QUIZSET' | 'BOARD';

/** 학생 상세 진입 시 '포인트 기록' 탭을 열어두는 `?panel=` 값. */
export const STUDENT_DETAIL_PANEL_QUERY = 'panel';
export const STUDENT_DETAIL_POINT_PANEL_QUERY_VALUE = 'points';
const studentList = (classroomId: string) =>
  `/classrooms/${classroomId}/students` as const;

const content = (classroomId: string, tab: ClassroomContentTab) =>
  `/classrooms/${classroomId}/${
    tab === 'QUIZSET' ? 'quizzes' : 'boards'
  }` as const;

const materials = (classroomId: string) =>
  `/classrooms/${classroomId}/materials` as const;

export const CLASSROOM_ROUTES = {
  list: () => '/classrooms' as const,
  materials,
  /**
   * 클래스 진입 경로. 호출자가 사용자의 소유 여부를 알고 있으면
   * `isOwner` 를 넘겨 role-resolution hop 을 건너뛴다.
   * owner·참여자 모두, 데스크탑·모바일 모두 학생 탭으로 진입한다
   * (학생 탭에서 퀴즈·보드로 이동 가능). 모르면 `/classrooms/{id}` 로 진입해
   * `ClassroomDetailPageView` 가 클라이언트에서 role 을 조회해 replace 한다.
   */
  detail: (
    classroomId: string,
    isOwner?: boolean,
    // options 는 하위호환용. 현재는 진입 탭 결정에 쓰지 않는다.
    _options?: { isMobile?: boolean },
  ): string => {
    if (isOwner === true || isOwner === false) {
      return studentList(classroomId);
    }
    return `/classrooms/${classroomId}`;
  },
  studentList,
  studentDetail: (classroomId: string, userId: string) =>
    `/classrooms/${classroomId}/students/${encodeURIComponent(
      userId,
    )}` as const,
  /**
   * 학생 상세를 '포인트 기록' 탭이 열린 상태로 연다.
   * (탭은 로컬 상태라 진입 시점에만 이 쿼리로 초기값을 정한다.
   *  `__pointHistoryPreview` 는 목업 데이터까지 주입하는 디버그 플래그라 쓰지 않는다)
   */
  studentPointHistory: (classroomId: string, userId: string) =>
    `/classrooms/${classroomId}/students/${encodeURIComponent(
      userId,
    )}?panel=${STUDENT_DETAIL_POINT_PANEL_QUERY_VALUE}` as const,
  content,
  join: (classroomId: string, code?: string) =>
    code
      ? (`/classrooms/${classroomId}/join?code=${encodeURIComponent(
          code,
        )}` as const)
      : (`/classrooms/${classroomId}/join` as const),
} as const;
